import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Spinner } from "./Spinner";

// Réplica do PrimaryButton original (reference/expo-frontend/components/
// PrimaryButton.tsx): altura 52, radius 14, Inter SemiBold 15, variantes
// primary/secondary/ghost/danger, pressed = opacity .85 + scale .98.
type Variant = "primary" | "secondary" | "ghost" | "danger";

const VARIANT_CLASSES: Record<Variant, string> = {
  primary: "bg-primary text-primary-foreground border-transparent",
  secondary: "bg-secondary text-secondary-foreground border-transparent",
  ghost: "bg-transparent text-foreground border-border",
  danger: "bg-destructive text-destructive-foreground border-transparent",
};

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  title: string;
  icon?: ReactNode;
  variant?: Variant;
  loading?: boolean;
};

export function Button({
  title,
  icon,
  variant = "primary",
  loading,
  disabled,
  className = "",
  ...rest
}: Props) {
  return (
    <button
      disabled={disabled || loading}
      className={`flex h-13 items-center justify-center gap-2 rounded-(--radius-btn) border px-4.5 text-[15px] font-semibold transition-[opacity,transform] active:scale-[0.98] active:opacity-85 disabled:pointer-events-none disabled:opacity-50 ${VARIANT_CLASSES[variant]} ${className}`}
      {...rest}
    >
      {loading ? (
        <Spinner size={20} className="border-current/30 border-t-current" />
      ) : (
        <>
          {icon}
          {title}
        </>
      )}
    </button>
  );
}
